import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that shows a pre-order banner when the active variant is sold out.
 * Listens for variant update events and toggles its visibility based on variant.available.
 *
 * @extends {Component}
 */
class PreorderBanner extends Component {
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card, .shopify-section');
    if (!this.#target) return;
    this.#target.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (!this.#target) return;
    this.#target.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#target = null;
  }

  #onVariantUpdate = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
      const newUrl = event.detail.data.newProduct.url;
      if (newUrl) {
        this.dataset.productBaseUrl = newUrl.startsWith('http') ? newUrl : `${window.location.origin}${newUrl}`;
      }
    } else if (event.detail?.data?.productId && event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const variant = event.detail?.resource;
    const isSoldOut = !variant || variant.available === false;

    if (isSoldOut) {
      this.removeAttribute('hidden');
    } else {
      this.setAttribute('hidden', '');
    }

    this.#updateWhatsAppLink(variant);
  };

  #updateWhatsAppLink(variant) {
    const link = this.querySelector('[data-preorder-wa-link]');
    if (!link) return;

    const number = this.dataset.wspNumber;
    if (!number) return;

    const baseUrl = this.dataset.productBaseUrl || '';
    const productUrl = variant?.id ? `${baseUrl}?variant=${variant.id}` : baseUrl;

    const detailsLine = variant?.name || this.dataset.productTitle || '';
    const messageBase = this.dataset.wspMessage || '';

    const fullMessage = [messageBase, '', detailsLine, productUrl].join('\n').trim();

    link.href = `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(fullMessage)}`;
  }
}

if (!customElements.get('preorder-banner')) {
  customElements.define('preorder-banner', PreorderBanner);
}
